module.exports = __webpack_public_path__ + "1-13.png?a952640954b8781413495df40c6c36ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-13.png
// module id = 90
// module chunks = 0